import UserAvatarPlaceholder from '../UserAvatarPlaceholder';

const UserAvatar = ({ url, name = '' }) => {
    return(
        <div className="userAvatar">
            {url
                ? <img
                src={url || undefined}
                alt={name}
                onError={(e) => {
                    e.target.style.display = 'none';
                }}
            /> : <UserAvatarPlaceholder className="userAvatar__placeholder" />}
        </div>
    )
}

export default UserAvatar;